import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Icon } from "semantic-ui-react";
import { toMoney } from "../../../../utils/formatter";

import "./innerCard.scss";

export default function InnerCard({
  header,
  headerColor,
  borderColor,
  data,
  showIcon,
  iconColor,
  onClick,
  type,
  disabled = true,
  opacity = 1,
}) {
  const { t } = useTranslation("finance");

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <Icon circular inverted color={iconColor} name={showIcon} disabled={disabled} />
      <Card
        className={"fcSidebarCard"}
        header={header}
        meta={toMoney(Math.round(data?.total || 0)) || 0}
        description={t("cashflowAreaDetail.recordsCount", { count: data?.count || 0 })}
        style={{
          "--headerBackground": headerColor,
          "--borderColor": borderColor,
          opacity
        }}
        onClick={() => onClick(type)}
      ></Card>
    </div>
  );
}
